import React from "react";
import * as S from "./index-styled";
import HomeIcon from "_c/icon/Home";
import ArrowLeftIcon from "_c/icon/ArrowLeft";
import PlusIcon from "_c/icon/Plus";
import { CircleButton } from "_c/button";
import { Link } from "react-router-dom";
import qs from "query-string";
import isempty from "lodash/isEmpty";
import DenyIcon from "_c/icon/Deny";
import PT from "prop-types";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { useHistory, useLocation } from "react-router-dom";
import { useParsedQuery } from "@/hooks/useParsedQuery";

const ns = "blog:tooltips";
const Nav = ({ canCreateArticle, t }) => {
  const history = useHistory();
  const location = useLocation();
  const { tag: tags } = useParsedQuery();
  const removeTag = (tag) => {
    const query = qs.parse(location.search);
    query.tag = (Array.isArray(query.tag) ? query.tag : [query.tag]).filter(
      (_tag) => _tag !== tag
    );
    history.push("/blog?" + qs.stringify(query));
  };
  return (
    <S.Nav>
      <ul>
        <li>
          <CircleButton
            title={t(`${ns}.home`)}
            as={Link}
            to={LinkGenerator.blogHome()}
          >
            <HomeIcon color="white" />
          </CircleButton>
        </li>
        <li>
          <CircleButton
            title={t(`${ns}.back`)}
            onClick={() => history.goBack()}
          >
            <ArrowLeftIcon color="white" />
          </CircleButton>
        </li>
        <li>
          {canCreateArticle && (
            <CircleButton
              title={t(`${ns}.add_article`)}
              as={Link}
              to={LinkGenerator.blogEditor()}
            >
              <PlusIcon color="white" />
            </CircleButton>
          )}
        </li>
      </ul>
      {!isempty(tags) && (
        <S.Tags>
          {(Array.isArray(tags) ? tags : [tags]).map((tag) => (
            <li key={tag}>
              <span>{tag}</span>
              <button onClick={() => removeTag(tag)}>
                <DenyIcon width="7" color="white" />
              </button>
            </li>
          ))}
        </S.Tags>
      )}
    </S.Nav>
  );
};
Nav.propTypes = {
  history: PT.object,
  location: PT.object,
  canCreateArticle: PT.bool,
  t: PT.func.isRequired,
};

export default Nav;
